import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResourceTeam, ResourceTeamSave, ResourceUserOption } from '../../../../Models/resource-modules.models';

export interface ResourceTeamFormDialogData {
  /** null = neues Team. */
  team: ResourceTeam | null;
  userOptions: ResourceUserOption[];
  currentUserId: string;
  /** SuperAdmin/Kaufmännisch dürfen beim Anlegen eine andere Teamleitung bestimmen. */
  canChooseLeader: boolean;
}

/** Einheitlicher Dialog zum Anlegen und Bearbeiten eines Teams. Liefert die Speicherdaten. */
@Component({
  selector: 'app-resource-team-form-dialog',
  templateUrl: './resource-team-form-dialog.component.html',
  styleUrls: ['../resource-team-management.shared.css', './resource-team-form-dialog.component.css']
})
export class ResourceTeamFormDialogComponent {
  name: string;
  description: string;
  isActive: boolean;
  memberIds: string[] = [];
  leaderId: string;
  memberSearch = '';

  constructor(
    private dialogRef: MatDialogRef<ResourceTeamFormDialogComponent, ResourceTeamSave>,
    @Inject(MAT_DIALOG_DATA) public data: ResourceTeamFormDialogData
  ) {
    this.name = data.team?.name ?? '';
    this.description = data.team?.description ?? '';
    this.isActive = data.team?.isActive ?? true;
    this.leaderId = data.currentUserId;
  }

  get creating(): boolean { return this.data.team === null; }

  get memberOptions(): ResourceUserOption[] {
    const q = this.memberSearch.trim().toLocaleLowerCase('de');
    return this.data.userOptions.filter(u =>
      (!q || u.name.toLocaleLowerCase('de').includes(q) || (u.email ?? '').toLocaleLowerCase('de').includes(q)) ||
      this.memberIds.includes(u.userId));
  }

  get leaderOptions(): ResourceUserOption[] {
    const ids = new Set([...this.memberIds, this.data.currentUserId]);
    return this.data.userOptions.filter(u => ids.has(u.userId));
  }

  save(): void {
    const name = this.name.trim();
    if (!name) return;
    this.dialogRef.close(this.creating
      ? {
        name,
        description: this.description.trim() || null,
        isActive: true,
        memberUserIds: this.memberIds,
        leaderUserId: this.data.canChooseLeader ? (this.leaderId || this.data.currentUserId) : null
      }
      : {
        name,
        description: this.description.trim() || null,
        isActive: this.isActive
      });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
